import {
  connectWalletType,
  disconnectWalletType, getBaseTokenBalanceType,
  IAction, INetwork,
  setNetworkType,
  toggleLedgerModalType,
  toggleModalType,
  toggleTrezorModalType,
} from './stateConstants';
import { IContextState } from './store';

type TReducer<T = any> = (state: IContextState, action: IAction<T>) => any;

const setModalState: TReducer = (state, action) => ({
  isModalOpen: !!action.payload,
  ...(!action.payload && { isLedgerModalOpen: false }),
  ...(!action.payload && { isTrezorModalOpen: false }),
});

const setNetwork: TReducer<INetwork> = (state, action) => ({
  network: action.payload,
});

const connectWalletRequest: TReducer = (state, action) => ({
  connectingWallet: true,
  connectingWalletType: action.payload,
  connectionError: '',
});

const connectWalletSuccess: TReducer = (state, action) => ({
  connectingWallet: false,
  isLedgerModalOpen: false,
  isTrezorModalOpen: false,
  connectingWalletType: null,
  account: action.payload.account,
  accountType: action.payload.connectionType,
  networkId: action.payload.networkId,
  // provider: action.payload.provider,
  balanceWei: '0',
});

const connectWalletFailed: TReducer = (state, action) => ({
  connectingWallet: false,
  connectingWalletType: null,
  connectionError: action.payload,
});

const setLedgerPathsSelector: TReducer = (state, action) => ({
  isLedgerModalOpen: action.payload,
  connectingWallet: false,
  connectingWalletType: action.payload && state.connectingWalletType,
});

const setTrezorPathsSelector: TReducer = (state, action) => ({
  isTrezorModalOpen: action.payload,
  connectingWallet: false,
  connectingWalletType: action.payload && state.connectingWalletType,
});

const disconnect: TReducer = () => ({
  connectingWallet: false,
  isLedgerModalOpen: false,
  isTrezorModalOpen: false,
  connectingWalletType: null,
  account: null,
  accountType: null,
  networkId: null,
});

const setBaseTokenBalanceRequest: TReducer = () => ({
  balanceLoading: true,
});

const setBaseTokenBalanceFailed: TReducer = (state, action) => ({
  balanceLoading: false,
  balanceError: action.payload,
});

const setBaseTokenBalanceSuccess: TReducer = (state, action) => ({
  balanceLoading: false,
  balanceWei: action.payload,
});

const reducers = {
  [toggleModalType.set]: setModalState,
  [toggleLedgerModalType.set]: setLedgerPathsSelector,
  [toggleTrezorModalType.set]: setTrezorPathsSelector,
  [connectWalletType.request]: connectWalletRequest,
  [connectWalletType.success]: connectWalletSuccess,
  [connectWalletType.failed]: connectWalletFailed,
  [getBaseTokenBalanceType.request]: setBaseTokenBalanceRequest,
  [getBaseTokenBalanceType.failed]: setBaseTokenBalanceFailed,
  [getBaseTokenBalanceType.success]: setBaseTokenBalanceSuccess,
  [disconnectWalletType.set]: disconnect,
  [setNetworkType.set]: setNetwork,
};

export const ppcReducer: TReducer = (state, action) => {
  if (!reducers[action.type]) {
    console.warn('NO_REDUCER FOR', action.type, action.payload);
    return state;
  }
  return { ...state, ...reducers[action.type](state, action) };
};

export default ppcReducer;
